
export enum SavedSearchPages {
  Project = 'projects',
  Organization = 'organizations',
  VideoMenus = 'video-menus',
  Customers = 'customers',
  Videos = 'videos',
  Teams = 'team',
  PromotionCodes = 'promotion-codes',
  Orders = 'orders',
  Media = 'media',
}

class SavedSearchService {
  static getValue = (page: SavedSearchPages): string => {
    const savedSearch = localStorage.getItem(`listTableSearch.${page}`);
    localStorage.removeItem(`listTableSearch.${page}`);
    return savedSearch || '';
  };

  static setValue = (page: SavedSearchPages, search: string): void => {
    localStorage.setItem(`listTableSearch.${page}`, search);
  };
}

export default SavedSearchService;
